"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitFor = void 0;
/**
 * Repeatedly calls the callback until it resolves or the timeout is reached.
 *
 * @param callback - An async function
 * @param options
 * @param options.timeout - The overall timeout in milliseconds
 * @param options.interval - The time to wait between retries in milliseconds
 * @param options.onError - A function that is called when the callback throws an error. Useful for debugging errors.
 * @returns The result of the callback if it is successful
 */
async function waitFor(callback, options = {}) {
    const timeout = options.timeout || 20000;
    const interval = options.interval || 1000;
    const onError = options.onError || (() => { });
    return new Promise((resolve, reject) => {
        let lastError = null;
        const timeoutId = setTimeout(() => {
            onDone(lastError || new Error(`Timeout exceeded: ${timeout}ms`), null);
        }, timeout);
        const intervalId = setInterval(() => {
            callback()
                .then(result => onDone(null, result))
                .catch(error => {
                lastError = error;
                onError(error);
            });
        }, interval);
        function onDone(error, result) {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
            if (error) {
                reject(error);
            }
            else {
                resolve(result);
            }
        }
    });
}
exports.waitFor = waitFor;
